import { validateAndSendVerificationCode } from 'Api';
import { useMutation } from 'react-query';
import { INewUserRequestbody } from 'Types/Interface/IUser';

export const useValidateAndSendVerification = () => {
	return useMutation((data: INewUserRequestbody) => validateAndSendVerificationCode(data));
};
